import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import adminLogo from "../../../assets/images/admin.png";
import { verifyAdmin } from "../../../utils/verifyAdmin";
const BASE_URL = process.env.REACT_APP_BASE_URL;

function AdminLogin() {
  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const [isAdmin, setIsAdmin] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    verifyAdmin()
      .then(() => {
        navigate("/admin");
      })
      .catch(() => {
        setIsAdmin(false);
      });
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("username", data.username);
    formData.append("password", data.password);
    try {
      console.log(BASE_URL);
      const response = await axios.post(`${BASE_URL}/auth/login`, formData);

      if (response.data.success === false) {
        alert(response.data.message);
      } else {
        localStorage.setItem("token", response.data.token);
        window.location.href = "/admin";
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleHome = (e) => {
    e.preventDefault();
    setData({
      username: "",
      password: "",
    });
    navigate("/");
  };

  if (!isAdmin) {
    return (
      <>
        <div className="hero is-light is-fullheight">
          <div className="hero-head"></div>
          <div className="hero-body">
            <div className="container">
              <form>
                <div className="columns">
                  <div className="column is-half">
                    <div className="container">
                      <figure className="image">
                        <img
                          style={{
                            width: "100%",
                            height: "auto",
                          }}
                          src={adminLogo}
                          alt="Admin Logo"
                        />
                      </figure>
                    </div>
                  </div>
                  <div id="make-center" className="column is-half">
                    <div
                      className="card  has-background-light"
                      style={{
                        width: "100%",
                        backgroundColor: "#bbbbbb",
                      }}
                    >
                      <header className="card-header">
                        <p className="card-header-title is-3">Admin Login</p>
                      </header>
                      <div className="card-content">
                        <div className="field">
                          <label className="label">Username</label>
                          <div className="control">
                            <input
                              autoFocus
                              onChange={handleChange}
                              name="username"
                              className="input"
                              type="text"
                              placeholder="admin"
                              value={data.username}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="field">
                          <label className="label">Password</label>
                          <div className="control">
                            <input
                              onChange={handleChange}
                              name="password"
                              className="input"
                              type="password"
                              placeholder="password"
                              value={data.password}
                              required
                            ></input>
                          </div>
                        </div>

                        <div className="field is-grouped">
                          <div className="control">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              className="button is-link is-success"
                            >
                              Login
                            </button>
                          </div>
                          <div className="control">
                            <button
                              type=""
                              onClick={handleHome}
                              className="button is-link is-light is-info"
                            >
                              Back to Home
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="hero-foot"></div>
        </div>
      </>
    );
  } else {
    return null;
  }
}

export default AdminLogin;
